<!DOCTYPE html>
<html lang="tr-TR">

<head>
	<title>CARDATA Türkiye'nin Lider Otomotiv Datası Şirketi</title>
	<meta charset="utf-8" />
	<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
	<base href="/">
	<script src="assets/js/jquery-3.3.1.js"></script>
	<script src="assets/js/plugins/jquery.masknumber.min.js"></script>
</head>

<body>
	<div class="page">
		<div class="container-fluid login">
			<div class="row">
				<div class="col-md-12">
					<div class="box mt40 mb40 static">
						<div class="row">
							<div class="col-lg-12">
								<div class="static-content">
									<p><b>Lütfen Üye olmadan önce ‘Kullanım Koşullarını’nı dikkatlice okuyunuz.</b></p>
									<p><b>Kullanım Koşulları:</b></p>
									<p><b>1) Taraflar ve Tanımlar:</b></p>

									<p><b>1.1.ŞİRKET :</b> CDI Otomotiv Bilgi Hizmetleri A.Ş. - Car Data Internatıonal,
										Koşuyolu Mh. Halili Sk. No:9/2 34718 Kadıköy / İstanbul, Ticaret Sicil No:
										828237, Mersis No: 0203031125400012 (kısaca “Şirket” veya “CDI” olarak
										anılacaktır)</p>

									<p><b>1.2.ÜYE :</b> Dijital ortamda bilgilerini girerek talepte bulunmuş ve kayıt yaptırmış
										olan, kayıt ve üyelik esasıyla, tanıtım amacıyla sunulmuş ücretsiz Demo
										vasıtasıyla veya daha sonra ücretli olarak uygulamayı kullanan gerçek ve tüzel
										kişileri (kısaca “Üye” veya “Kullanıcı” olarak anılacaktır)</p>

									<p><b>1.3.UYGULAMA :</b> CDI’a ait olan ve web sayfasında, IOS veya Android mağazalarında
										sunulan veri analiz tabanlı “CARDATA” uygulamasını (kısaca “Uygulama” veya
										“Modül” olarak anılacaktır)</p>

									<p><b>1.4.DOĞRULAMA :</b> Üyelik kayıtlarının oluşturulması, ücretli veya demo
										uygulamalarda üye kullanıcıların hizmetlerden faydalanabilmesi ve buna ilişkin
										süreçlerin yürütülebilmesi, sisteme girişte kullanabilmesi veya sorgulama
										yapılabilmesi gibi amaçlarla şirket veya iş ortakları tarafından Üye’nin
										iletişim adresine CDI tarafından oluşturularak ulaştırılan veya hizmetten
										faydalanan kişi tarafından oluşturulan şifre, parola, üye/kullanıcı adı, kodu,
										link gibi kişiye özel teyit/tanıma/giriş verisi yahut sembolünü yahut onaylama
										işlemini,</p>

									<p><b>1.5.DEMO :</b> Uygulamanın deneyimlenmesi ve tanıtımı amacıyla Üye olan kişilere
										tanınan Sınırlı-Süreli ve Ücretsiz hali (Koşulları ve içeriği CDI tarafından
										belirlenmiş olan ve CDI tarafından her zaman değiştirme, sınırlama, içeriği
										değiştirme, kısmen veya tamamen kaldırma hakkı saklıdır)
									<p><b>1.6.ALICI :</b> Uygulamaya işbu sözleşmede belirlenen yöntemlerle kayıt olup,
										uygulama tarafından sunulan ürünlerden ücret karşılığı faydalanmak için süreli
										kullanım hakkı satın alan gerçek ve tüzel kişi Üyeler, (kısaca Alıcı veya
										Kullanıcı olarak anılacaktır)</p>

									<p><b>1.7.SÖZLEŞME:</b> Ücretli uygulamalarda her bir hizmet veya uygulama özelinde
										yapılabilen, elektronik onay şeklinde veya yazılı olarak akdedilen, işbu
										Kullanım Koşullarının ve CDI’ın web veya mobil sitesinde yer alan diğer
										dokümanların her birisinin kendisinin eki olarak kabul edildiği Üye veya Alıcı
										tarafından elektronik olarak onaylanmış taraflar arasında yapılmış anlaşmayı
										(ileride ücretli kullanım hakkı satın alınması halinde ayrıca yapılmış bir
										sözleşmesi olmadığı taktirde iş bu kullanım koşulları aynı zamanda Sözleşme
										hükmündedir.)
										ifade etmektedir.</p>

									<p>ifade etmektedir.</p>


									<p><b>2.) Uygulama ve Hizmetler:</b>

									</p>
									<p><b>2.1. CDI’a ait CARDATA Uygulamasında bulunan sorgulamalar;</b>
									</p>
									<p><b>* 2.El Araç Fiyat Sorgulaması</b> (olası Minimum-Maximum ve Ortalama Fiyat olarak
										Alış ve Satış fiyatı
										değerleri ile Teknik ve Donanım bilgileri)
									</p>
									<p><b>* 0 Km Araç Fiyat Sorgulaması</b> (Fiyat ile Teknik ve Donanım bilgileri)
									</p>
									<p><b>* Karşılaştırma Sorgulaması</b> (0 Km ve 2.El, Teknik ve Donanım bilgileri)
										şeklindedir.

									</p>
									<p><b>2.2.</b> Demo, CARDATA uygulamasının, tanıtım amacıyla Üye kaydı yapan kişiye
										ücretsiz olarak beş adet 2.El Fiyatlandırma sorgulaması yapma hakkı tanıyan
										sınırlı halidir. Ancak Demo hiçbir şekilde Üye için kazanılmış hak teşkil etmez
										ve ŞİRKET’in dilediği zaman, herhangi bir gerekçe göstermeden ve önceden
										bildirim mecburiyeti olmaksızın Demo uygulaması içeriğini değiştirme veya
										içerikte kısıtlamaya gitme, sorgulama türlerini değiştirme, sorgu sayısını
										arttırma veya azaltma yahut uygulamayı kısmen veya tamamen durdurma veya
										kaldırma, Üye’liği iptal gibi her türlü değişikliği ve ipatl hakkı saklıdır.

									</p>
									<p><b>2.3.</b>Yukarıda belirtilenler ve bunlarla sınırlı olmamak üzere süreç içerisinde CDI
										tarafından geliştirilerek uygulama içerisinde kullanıma sunulacak sair
										hizmetler/sorgulamalar aksi belirtilmedikçe işbu Kullanım Koşul ve Hükümlerine
										tabidir.


									</p>
									<p><b>3.) Kullanım Koşulları ve Hizmetlerin Mahiyeti:</b>

									</p>
									<p><b>3.1.</b> İş bu Kullanım Koşulları; Üye olma koşulları ile web sayfası üzerinden veya
										mobil tabanlı olarak uygulamayı kullanımınıza, hizmetlerden faydalanmanıza,
										uygulamanın niteliklerine, tarafların hak ve yükümlülüklerine, CDI tarafından
										sunulmuş hizmet ve ürünlerin mahiyetine ve kullanımına ilişkin genel şartları ve
										hükümleri içermektedir.

									</p>
									<p><b>3.2.</b> Uygulamanın kullanılabilmesi ve kötüniyetli/haksız kullanımların önüne
										geçilebilmesi için ÜYE olma koşulu bulunmaktadır. ÜYE olmak için web sayfası
										veya indirilecek mobil uygulamasında çıkacak olan üyelik formda istenen (ad,
										soyad, şehir, bayi/galleri/şirket adı, cep telefonu numarası, mail adresi gibi)
										bilgilerin gerçeğe uygun ve tam olarak doldurulmuş ve sistem üzerinden gerekli
										“onay”ların kişi tarafından verilmiş olması gerekmektedir. Kayıt sonrası CDI
										tarafından Üye’ye iletilecek şifre ile sisteme giriş yapılabilecektir. Şifre ve
										kullanıcı adı Üye’nin kayıt esnasında forma girdiği cep telefonu numarasına SMS
										olarak gönderilecektir. CDI, her hangi bir sebep göstermeksizin Üye’liğe kabul
										etmeme veya Üye’liği iptal hakkına sahiptir. Ücretli uygulama satışlarına
										ilişkin hükümler saklıdır.

									</p>
									<p><b>3.3.</b> Üye’lerden topladığımız ve bu kişilerin Üyelik kaydı ve sonrasında
										sağladıkları kişisel verilerin işlenmesi ile ilgili bilgilendirmeyi içeren
										dokümanlarımız (Gizlilik Politikası – Kişisel Verilerin İşlenmesi Hakkında
										Aydınlatma Metni ve Açık Rıza Beyanı) sayfamızda yer almakta olup, onayınız ile
										verileriniz işlenmekte ve ilgili doküman kapsamında belirtilen koşullarla
										kullanılmakta ve paylaşılmaktadır.

									</p>
									<p><b>3.4.</b> Uygulama geniş kapsamlı olmakla birlikte, CDI’ın uygulamada tüm araç marka
										ve modellere ilişkin veri olduğu yönünde bir vaadi veya taahhüdü
										bulunmamaktadır.

									</p>
									<p><b>3.5.</b> Uygulamada yapılan sorgulamalara ait sonuçlar, sadece sorgulama yapan kişiye
										fiyat konusunda fikir vermeye yönelik yaklaşık/öngürü/refarans değerler olup,
										kesinlik arz etmemektedir. Sorgulamada çıkan fiyatlara ilişkin olarak CDI’ın
										herhangi bir sorumluluğu, taahhüdü veya garanti vaadi bulunmamaktadır.

									</p>
									<p><b>3.6.</b> CARDATA uygulaması bir ilan veya açık pazar sayfası olmayıp, hiçbir şekilde
										CDI veya 3.kişiler tarafından yapılmış bir araç alım veya satım teklifi de
										değildir.

									</p>
									<p><b>3.7.</b> Uygulamanın sunmuş olduğu değerler/sorgulama sonuçları öngörü niteliğinde
										olup herhangi bir kesinlik ifade etmemektedir. CDI’ın sorgulama neticesi gelecek
										fiyatlandırmalar ve teknik-donanım bilgilerine ilişkin Üye’ye her hangi bir
										taahhüdü, garantisi veya vaadi bulunmamaktadır. CDI, uygulamaya kullanan
										kişilerin gerçekleştirecekleri iş, işlem ve ticaretin doğrudan veya dolaylı bir
										parçası, aracısı, garantörü, kefili veya tarafı olmayıp, hiçbir sorumluluğu
										bulunmamaktadır.

									</p>
									<p><b>3.8</b> 2.El Fiyat Sorgulaması uygulaması 2.el bir aracın güncel referans piyasa
										değerlerini Türk Lirası cinsinden ve olası olarak veren bir uygulamadır. Modül,
										girilen verilere göre 2006 sonrası model tiplerinin 0 kilometre ile 400.000
										kilometre arasındaki referans, kaynak ve öngörü ikinci el değerlerinin
										referanslarını sunmaktadır. Ancak içinde bulunulan yıla ait modellerin
										verilerinin toplanması ve CDI açısından anlamlı hale gelmesinden sonrası sisteme
										yüklenebilmektedir.

									</p>
									<p><b>3.9.</b> CDI, profesyonel ve bağımsız bir pazar gözlemcisi, araç datası ve ikinci el
										fiyat datası sağlayıcısı şirketidir. Cardata uygulamasında sunulan araç ve
										ikinci el araç fiyatları, Cardata’nın Türkiye pazarı için kendi uzmanlığı,
										tecrübesi ve geliştirmiş olduğu know-how’a göre belirlenmiş ve sunmuş olduğu
										“referans”, “kaynak” ve “öngörü” değerlerdir. Modülde sunulan 2.el araçlar
										sadece binek otomobilleri ve hafif ticari araçları kapsamaktadır.

									</p>
									<p><b>3.10.</b> İkinci el araç değerleri göreceli bir kavram olmanın yanı sıra, kişiden
										kişiye, kurumdan kuruma ve aracın fiziki gerçek durumuna göre değişim gösterir.
										Türkiye otomotiv pazarında hiçbir ikinci el araç için kesin bir güncel fiyat
										değeri yoktur; çünkü ikinci el araç fiyatları araçların sahip oldukları donanım,
										aksesuar, motor, kaporta, hasar, hazar durumu, ekspertiz, kilometre, model yılı,
										şanzıman, yakıt tipi, yaş, kullanım şekli, yıpranmışlık durumu, renk, şehir ve
										bölge gibi çok çeşitli faktörlere göre farklılıklar gösterir. Bu sebeplerden
										dolayı uygulamada sunulan ikinci el araç referans değerleri, araç sahibinin,
										alıcının, diğer kurum veya kişilerin belirlediği fiyatlara, diğer fiyat
										değerlendirme araçlarına, modüllerine ve uygulamalarına, hatta ve hatta
										hizmetten faydalananın kendisinin belirlediği fiyatlara göre dahi fiyat
										farklılıkları gösterebilir. Ayrıca uygulamanın geliştirilmesi esas olmakla ve
										sürekli güncellemeler yapılmakla birlikte günümüzün ekonomik koşullarındaki
										hızlı değişiklikler, döviz kurlarındaki dalgalanmalar, üretim, tedarik ve
										lojistik problemleri, küresel gelişmeler, üretici ve distribütörlerin ani fiyat
										değişiklik ve güncellemeleri gibi bir çok faktör nedeniyle 0 Km ve ikinci el
										araç fiyatları günlük bazda dahi değişir hale gelmiştir. Gerek bu nedenlerle,
										gerekse veri toplama ve sisteme giriş periyot ve süreçleri dolayısıyla
										sorgulamalarda piyasayla eş zamanlı ve kesin bir fiyatlandırma yapmak mümkün
										değildir ve CDI’ın bu yönde bir vaadi, garantisi ve taahhüdü bulunmamaktadır.

									</p>
									<p><b>3.11.</b> Uygulama üzerinden yapılacak sorgulamada istenen tüm veriler, uygulamayı
										kullanan kişi tarafından tek taraflı şekilde girilebilmektedir. Uygulamaya,
										kullanıcı tarafından girilen bilgilerin (marka, model, model yılı, vites, hasar
										vs gibi uygulamada yer alan tek yönlü veri girişleri) doğruluğu ve gerçekliği
										hakkında CDI’ın teyit imkanı olmadığından CDI’ın, kullanıcıya karşı hiçbir
										sorumluluğu ve taahhüdü bulunmamaktadır.

									</p>
									<p><b>3.12.</b> Uygulamanın sunmuş olduğu ikinci el araç değerleri, uygulamayı kullanacak
										kişi tarafından girilen verilere göre değişiklik arz eden ve nihayetinde fikir
										verici bir referans, kaynak ve öngörü değerleridir. Modülün sunmuş olduğu
										değerler herhangi bir kesinlik ifade etmemektedir.

									</p>
									<p><b>3.13.</b> Uygulama Kullanıcısından beklenen, modülde oluşan fiyatların yine
										kendisinin belirleyeceği araç veya 2.el araç fiyatlarına ön hazırlık, referans,
										öngörü ve kaynak olmasıdır. Yani uygulama fiyatlamasının fikir vermeye yönelik
										olduğunu Üye bilir ve kabul eder. Dolayısıyla Üye’nin uygulamayı kullanarak
										bulduğu araç değerleri üzerinden yapacağı araç alım-satım veya ticaretindeki tüm
										sorumluluk Üye’ye aittir. Üye, uygulamada sunulan 2.el araç fiyatlarını
										kullanması nedeniyle CDI’a karşı zarar iddiasında ve tazminat talebinde
										bulunmayacağını gayrıkabili rücu kabul, beyan ve taahhüt eder.

									</p>
									<p><b>3.14.</b> CDI, uygulamada sunulan ikinci el araç fiyatlarını piyasadan, otomobil
										satıcılarından, otomobil bayilerinden ve otomobil yetkili satıcılarından (ikinci
										el araç satış kanallarından) topladığı (saha datasına) “araçların gerçekleşen
										satış fiyatlarına” göre belirler. Bu nedenle bu araç satış kanallarında olmayan,
										bu araç satış kanallarında satılmayan veya hiç satılmamış olan, bu araç satış
										kanallarından Cardata tarafından toplanamayan ve elde edilemeyen bazı markaların
										ve bazı araç modellerinin uygulamada yer almadığını ve dolayısıyla bu araçların
										0KM ve 2.el fiyat datasının da uygulamada olmadığını Üye bilir ve kabul eder.

									</p>
									<p><b>3.15.</b> Uygulamada karşınıza çıkan ekrandaki bilgileri girdiğinizde araç veri
										sistemimizde otomatik olarak değerlendirmeye alınarak markası, modeli, model
										yılı, Km’si, hasar durumu gibi birtakım temel özellikleri girmeniz neticesinde
										karşınıza ortalama bir fiyat öngörüsü çıkacaktır. Bu fiyat veri tabanı üzerinden
										ortalama olarak en az-en çok ve ortalama fiyat aralığı belirlenme şeklinde
										verilecektir. Ancak uygulama tam bir kesinlik ve doğru fiyatı belirlemeyi
										garanti veya taahhüt etmemektedir. Aracın özelliklerine ve fiili durumuna göre,
										başka platform veya kanallarda daha yüksek veya düşük fiyatlarla değerleme
										yapılması mümkün olup, bu durum alıcıdan alıcıya ve satıcıdan satıcıya, piyasa
										koşulları ve hareketliliğine, aracın fiziki muayene ve ekspertizine, hatta
										tarafların ekonomik koşullarına bağlı olarak değişebilmektedir.
										Uygulamalarımızda/internet sitemiz üzerinden yapacağınız sorgulamalarda çıkan
										fiyat veya fiyat aralığı veri tabanındaki bilgiler çerçevesinde verilmekle
										birlikte nihayetinde bir öngörüdür ve kullanıcıya fikir vermeyi amaçlamaktadır.
										Buradaki değerleme temel bir değerleme olup, aracın kesin veya esas fiyatı
										olmadığını Üye bilir, kabul ve beyan eder.

									</p>
									<p><b>3.16.</b> CDI sorgulama uygulamaları, ilgili ekranda çıkan ve sizin tarafınızdan
										girilecek araç bilgilerine göre veri tabanı algoritması üzerinden otomatik
										olarak sonuç vermekte olduğundan tüm işlemleri gerçekleştirirken sizin doğru
										bilgileri verdiğiniz varsayımıyla hareket edilmektedir. Yanlış bilgi/veri girişi
										sebebiyle tüm sorumluluk Üye’ye aittir.

									</p>
									<p><b>3.17. </b>CDI, aynı zamanda piyasa aktörlerine veri-modül-uygulama hizmet veren bir
										otomotiv datası şirketidir. Bu nedenle CDI’ın sahibi bulunduğu
										uygulamaların/modüllerin aynı veya farklı adlar altında ve yönetim paneli bu
										üçüncü kişilere ait olmak üzere onların internet sayfalarına link vermesi veya
										bu kişilere ait internet sayfalarına yerleştirilmesi mümkündür. Aynı şekilde CDI
										bu kişilerin linklerine, internet sitesinde de yer verilebilir. Ancak bağlantı
										içeriklerinde CDI’ın hiçbir etkisi yoktur. CDI bu sitelerde sunulan bilgilerin
										doğruluğu, güncelliği veya hizmet kalitesinden sorumlu tutulamaz. Bu gibi
										durumlarda, 3.kişilere ait internet sayfalarından yapılacak sorgulamalardan ve
										kurulacak ilişkilerden CDI’ın hiçbir sorumluluğu bulunmamaktadır. CDI tarafından
										link verilmesi veya kendi sayfasına link alınması, hiçbir şekilde CDI’ın diğer
										firma ya da kişi ile iş ortağı olduğu, aracılık yaptığı, birlikte hareket ettiği
										veya birlikte ticari faaliyette bulunduğu şeklinde yorumlanamaz. Bu nedenle,
										kullanıcının/hizmetten faydalanın, reklam veya link üzerinden ulaştığı sayfa, bu
										sayfaların içeriği ve sayfa sahibi olan 3. kişilerle ilgili olarak ve keza
										kullanıcının bu kişi ile arasında olabilecek/yapılabilecek iş, işlem ve
										ticaretle ilgili olarak CDI’ın hiçbir ilgisi ve ilişkisi olmadığını, taraflar
										arasında kurulacak ilişkiye, ticarete, iş ve eylemlere ilişkin CDI’ın hiçbir
										sorumluluğu, taahhüt veya garantisi bulunmadığını Üye bilir ve kabul eder. Bu
										nedenle ÜYE, CDI’a karşı hiçbir hak, alacak veya zarar iddiasında
										bulunmayacağını, doğrudan veya dolaylı olarak CDI’ın konuyla ve karşı taraf ile
										ilişkisi bulunduğunu iddia ve ima etmeyeceğini ve hiçbir şekilde CDI’a kusur ve
										sorumluluk atfetmeyeceğini kabul, beyan ve taahhüt eder.

									</p>
									<p><b>3.18.</b> Demo sonrası ücretli olarak uygulamayı kullanmak isteyen Üye’lerin ŞİRKET
										ile iletişime geçmesi gerekmektedir. İş bu Kullanım Koşulları ile atıfta
										bulunduğu diğer dokümanlarda yer alan hükümlerin, ileride taraflar arasında
										yapılacak Sözleşme/lerin de ayrılmaz bir parçası olacağını, ayrıca bir sözleşme
										yapılmamış olması halinde işbu Kullanım Koşullarının taraflar arasında Sözleşme
										hükmünde olacağını Üye kabul beyan ve taahhüt eder.


									</p>
									<p><b>4.). Üye/Kullanıcı’nın Yükümlülükleri ve Taahhütleri:</b>

									</p>
									<p>Üye/Kullanıcı;

									</p>
									<p><b>4.1.</b> CARDATA uygulamasının marka, yazılım, alan adı, görselleri ve bilumum fikri
										ve mülki haklarının CDI’a ait olduğunu,

									</p>
									<p><b>4.2</b> İşbu Kullanım Koşullarını kabul etmekle, uygulamada yer alan, kullanıma ve
										hizmetlere ilişkin CDI tarafından belirlenen bilgi ve sistem güvenliği, kişisel
										verilerin korunması, gizlilik, uygulamaya giriş ve kullanım şartlarını kabul
										ettiğini,

									</p>
									<p><b>4.3.</b> Uygulamanın amacının; uygulamayı kullanan kişinin sorgulamak istediği araca
										ait bilgileri kendisi girerek bilgilendirme amaçlı olası referans fiyatlaması
										sorgulamasını (yaklaşık olarak minimum -maksimum -ortalama fiyat) bizzat
										kendilerince yapılmasını, teknik ve donanımsal özellikleri hakkında fikir
										edinmesini, 0Km araçlara ilişkin genel bilgilere ulaşmasını ve genel/yaklaşık
										bir karşılaştırma yapmasını sağlamak olduğunu,

									</p>
									<p><b>4.4.</b> Uygulama/ları web, Apple Store ve Google Play Store üzerinden telefonuna
										yükleyerek, kullanıcı adı ve oluşturulacak şifreyle sisteme giriş sağlayarak,
										bilgilerin kendisine ait olduğunu, uygulama tarafından sunulan veriler ve bunlar
										dışındaki tüm e-belge olabilecek içerikleri (xml, html, ekran kopyası vb.) alan
										veya uygulama adlarını, görsellerini sözleşme ilkelerine aykırı amaçlarla kısmen
										veya tamamen kendisi veya üçüncü kişiler aracılığı ile kullanmayacağını,
										kopyalamayacağını, paylaşmayacağını, çoğaltmayacağını, ilave veya çıkartmalar
										yapmayacağını,

									</p>
									<p><b>4.5.</b> Üye’nin sisteme erişim sağlayacağı cihazlarının donanımsal ve yazılımsal
										güvenliği ile varsa depolanan bilgilerin üçüncü kişilere karşı güvenliğinin
										sağlanması (virüs ve benzeri kötü amaçlı yazılımlar) konusunda sorumluluğun
										kendisine ait olduğunu ve bu gibi nedenlerle kendisinin ve/veya üçüncü kişilerin
										uğradığı veya uğrayabileceği zararlara dair sorumluluğu yüklendiğini,

									</p>
									<p><b>4.6.</b> Şifreli uygulamalarda, sisteme erişimde başkasına ait şifre
										kullanmayacağını, kendi şifresini başkasına kullandırmayacağını, kendi yetkileri
										dışındaki bilgilere erişim sağlamayacağını, sistemin genel güvenliğini ve mevcut
										yazılımların çalışmasını yavaşlatacak veya engelleyecek uygulama, yazılım ve
										donanım kullanmayacağını, bu kapsamda hiçbir şekilde robot yazılım ve donanım
										kullanarak giriş, sorgu veya benzeri işlemler yapmayacağını, sözleşmenin amacına
										aykırı hareket etmeyeceğini, uygulama içeriğinde yer alan bilgileri değiştirip
										ekleme yapmayacağını, eriştiği verileri hukuka aykırı kullanıma neden olacak
										şekilde kendisinin veya uygulamaya giriş için kullandığı uygulama ve yazılımlar
										nedeniyle üçüncü kişi ya da kurumun depolamayacağını ve kullanmayacağını,

									</p>
									<p><b>4.7.</b> Uygulama üzerinden sunulan hizmetin genel ve yaklaşık bir bilgilendirme
										amacıyla yapıldığını, CARDATA ve CDI android/app/wep sitesindeki sair
										uygulamaların, bunların Demoları ve bunlarla sınırlı olmamak üzere mevcut veya
										ileride çıkartılacak sair uygulama ve ürünlerimizde çıkan referans fiyatlar ve
										bilgilerin, sadece öngörü/bilgilendirme amaçlı olduğunu, kesinlik içermediğini,
										alıcı ve satıcı arasında nihai fiyatlamasının aracın fiziki durumu, muayenesi,
										ekspertiz ve benzeri gibi aracın gerçek durumuna göre değiştiğini bildiğini,
										hiçbir şekilde asgari bir fiyatlama yahut CDI tarafından doğrudan veya dolaylı
										olarak yapılmış bir araç satma veya satın alma taahhüdü, teklifi, icap veya
										kabulü anlamına gelmediğini, nihai olarak uygulamanın amacının araç alıcı veya
										satıcıları için değer hakkında olası / fikir vermeye yönelik bir
										değerlendirmeden ibaret olduğunu, bundan sonrasına ilişkin olarak Üye tarafından
										gerçekleştirilecek sürece dair CDI’ın her hangi bir dahili, taahhüdü ve
										sorumluluğu bulunmadığını,

									</p>
									<p><b>4.8.</b> Kendisine ait her türlü cihaz, yazılım ve donanımdan kaynaklı eksiklik,
										arıza ve kesinti ile internet servis sağlayıcılarından kaynaklanan kesinti veya
										arızadan dolayı hizmetlerden faydalanamaması veya süresinde işlem yapamaması
										halinde sorumluluğun kendisine ait olduğunu, uygulamaya yanlış veya eksik veri
										girişi durumunda veya doğruluğu halinde dahi CDI’ın herhangi bir sorumluluğunun
										olmadığını,

									</p>
									<p><b>4.9.</b> Sisteminin kullanımı, bakım ve idamesi, sistem güvenliğine yönelik
										çalışmalar ve güncellemeler sırasında ortaya çıkabilecek kısıtlama, cihaz
										arızası, iletişim kesintisi, iletişim yavaşlığı, hat yoğunluğu ve diğer idari
										veya teknik nedenlerden dolayı uygulama üzerinden sunulan hizmetlerin ilgili
										sistem üzerinden hizmetin yerine getirilememesi durumunda CDI’ın herhangi bir
										sorumluluğunun olmadığını,

									</p>
									<p><b>4.10.</b> CDI’ın kendiliğinden, hizmet gereği veya teknik zorunluluklar nedeniyle,
										tek taraflı olarak sistemi sürekli veya geçici olarak durdurma, uygulama
										içeriğini değiştirme, ücretli uygulamalarda sözleşme hükümleri saklı kalmak
										kaydıyla kısıtlama veya iptal etme hakkının olduğunu,

									</p>
									<p><b>4.11.</b> CDI’ın uygulamalar ve e-bülten üzerinden kendisinin ve başka bir şirketin
										duyuru, ilan, mesaj, anket, reklam, tanıtım, duyuru vb. işlemler yapabileceğini,

									</p>
									<p><b>4.12.</b> CDI’ın sunduğu hizmetin sürekliliğini veya hizmet kalitesini arttırmak
										için, tek taraflı değişiklik yapma hakkına sahip olduğunu, ücretsiz hizmetlere
										ilişkin sözleşmede ve kullanım koşullarında gerçekleştirilecek değişiklikler
										kullanıcı tarafından onaylanmadıkça uygulamaya giriş yapamayacağını,

									</p>
									<p><b>4.13.</b> Sisteme saldırı mahiyetinde eylemlerinin tespiti halinde uygulamaya giriş
										işleminin süreli veya süresiz olarak kısıtlanacağını ve ilgililer hakkında yasal
										işlemlere başlanacağını,

									</p>
									<p><b>4.14.</b> Kullanım koşullarına ve sözleşmeye aykırı davranışlar nedeniyle CDI’ın
										uğrayacağı veya kişi ve/veya kurumlara ödemek zorunda kalabileceği her türlü
										tazminat ve cezalar için kullanıcıdan talep veya kullanıcıya rücu hakkına haiz
										olduğunu,

									</p>
									<p><b>4.15.</b> Uygulamadaki hizmetin, “Olduğu Gibi” sunulduğunu ve CDI’ın, kullanıcıların
										kendine özel ihtiyaçlarını tamamen karşılayacağı şeklinde veya sorgulama
										sonuçlarının kesin olduğuna yönelik bir iddia veya taahhütte bulunmadığını,

									</p>
									<p><b>4.16.</b> Hizmetlere erişim kalitesinin büyük ölçüde kullandığı internet servis
										sağlayıcısının hizmet kalitesine bağlı olduğunu ve söz konusu hizmet
										kalitesinden kaynaklı sorunlarda CDI’ın herhangi bir sorumluluğunun
										bulunmadığını,

									</p>
									<p><b>4.17.</b> CDI’ın, uygulamaların her cihaz ya da web tarayıcı ile uyumlu olduğuna dair
										bir taahhüdü bulunmadığını,

									</p>
									<p><b>4.18.</b> Ücretli kullanım hakkı satışlarına ilişkin hükümler saklı kalmak kaydıyla,
										CDI’ın istediği zaman ve gerekçe göstermeden, bildirimde bulunmadan ve her hangi
										bir hukuki sorumluluğu olmadan Üyelik talebini reddedebileceğini veya mevcut
										Üye’liği feshedebileceğini, kullanımı geçici veya sürekli olarak
										durdurabileceğini,

									</p>
									<p><b>4.19.</b> Ücretli kullanım hakkı satın alınması halinde taraflar arasında ayrıca
										yapılmış bir sözleşmesi olmadığı taktirde iş bu kullanım koşullarının aynı
										zamanda Sözleşme hükmünde olduğunu ve Uygulama hakkında gerekli bilgilere sahip
										olarak ve Demo’sunu kullanarak, nihayetinde uygulamanın işleyişini ve verdiği
										fiyatlama ve sair teknik bilgi sonuçlarını önceden bilerek ve değerlendirerek
										satın aldığını, bu nedenle satış sonrası uygulamanın/modülün kendisi için
										faydalı olmadığı, ihtiyacının kalmadığı, kullanmadığı veya kulanamadığı, yeterli
										olmadığı vb gibi herhangi bir nedenle sözleşmenin feshini, iptalini, ücretin
										iadesini veya tenzili talep etmeyeceğini,

									</p>
									<p><b>4.20.</b> Kişisel Verilerinin İşlenmesi Hakkında Aydınlatma Metnini okuduğunu ve
										kişisel verilerin işlenmesine ilişkin Açık Rızayı verdiğini,
										Kabul Beyan Ve Taahhüt Etmiştir.

									</p>
									<p><b>5- Mobil Uygulamanın Ücretli Haline İlişkin Hükümler, Süreli Kullanım Hakkı
										Satışı ve Ödeme:</b>

									</p>
									<p><b>5.1</b> CARDATA uygulaması Demo hali dışında ücrete tabi bir uygulamadır. Ücretli
										kullanım hakkı satışı ile Alıcı, uygulamanın belirli bir süre boyunca (fiyat ve
										kampanyalar için şirket ile iletişime geçilmelidir) sınırsız kullanımı hakkını
										satın almış olur. Ücret ödemesi peşin olarak CDI’ın banka hesabına yapılır.

									</p>
									<p><b>5.2.</b>Alıcı tarafından satın alınan kullanım süresi (1 aylık, 1 yıllık vb gibi)
										faturada belirtilir ve Alıcının Üye kaydı sırasında verdiği mail adresine
										gönderilir. Kullanım süresi ödeme tarihinden itibaren işlemeye başlar. CDI,
										ödemenin yapıldığı tarihte uygulamayı Alıcı’nın kullanımına açacak ve ödeme
										yapılan tarihten başlamak üzere satın alınan sürenin sonuna kadar Alıcı’nın
										kullanımına açık kalacaktır. Uygulamanın Alıcı kullanımına açılması anında CDI
										edimini ifa etmiş ve tamamlamış olur. Kullanım süresi, uygulamanın fiilen
										kullanılıp kullanılmaması bakılmaksızın ödeme yapılan günden itibaren işlemeye
										başlayarak hesaplanır ve süre bitiminde sona erer. Bu sürenin sonunda sözleşme
										ve uygulamanın kullanım hakkı otomatikman sona erer.

									</p>
									<p><b>5.3.</b> Alıcı, satın aldığı kullanım süresi boyunca CARDATA uygulamasında sınırsız
										sorgulama yapma hakkına sahiptir. Haksız ve kötüye kullanım hallerine ilişkin
										hakları saklı kalmak kaydıyla, CDI sorgu adedinin fazlalığından bahisle ek ücret
										talebinde bulunamaz. Uygulamayı kullanıp kullanmamak veya kullanma sıklığı-sorgu
										adedi vs. tümüyle Alıcı’nın kendi inisiyatifinde olup, fiilen yapılmış sorgulama
										adeti veya sorgulama yapılan gün sayısı fiyatlandırma ve sözleşme süresi ile
										ilgili değildir. Bu nedenle ücretli kullanım hakkını alan Alıcı, uygulamayı
										kullandığı gün sayısına veya sorgu sayısına göre kıstelyevm usulü hesaplama
										yapılmasını ve ücrette iade yapılmasını isteyemez veya uygulamayı çok az
										kullandığı veya kullanamadığı vb. gibi gerekçelerle akdin iptalini, ücretin
										kısmen veya tamamen iadesi veya kullanım süresinin uzatılması talebinde
										bulunamaz. Her halükarda Alıcı’nın onayı ve sorgulama yapması ile ifasına/
										kullanımına başlamış sözleşmeden cayılamaz.

									</p>
									<p><b>5.4.</b> Üye tarafından ücretli kullanım hakkı satın alınması halinde ayrıca bir
										sözleşme yapılmamış ise işbu Kullanım Koşullarının taraflar arasında Sözleşme
										hükmünde olacağını Üye/Alıcı kabul beyan ve taahhüt eder.

									</p>
									<p><b>6.) Kullanım Koşullarının Sözleşmenin Eki ve Ayrılmaz Bir Parçası Olması:</b>
										</p>
									<p>İşbu Kullanım Koşulları aynı zamanda düzenlediği konu bakımından sizinle
										aramızda yapılmış veya ileride yapılacak olan Sözleşmelerin ayrılmaz bir
										parçasıdır. İşbu Kullanım Koşullarında onay vermeniz halinde bu Kullanım
										Koşullarında ve aramızda yapılmış/yapılacak Sözleşmede yer alan hususlar dışında
										hiçbir beyan, açıklama, taahhüt, güvence veya garanti vermediğimizi kabul etmiş
										olursunuz. Yarıca yapılmış bir sözleşme bulunmadığı müddetçe işbu kullanım
										koşulları Üye’lik süresi boyunca Sözleşme hükmündedir.

									</p>
									<p><b>7.) Koşullarda Değişiklik Yapma Hakkı:</b>
										CDI önceden herhangi bir bildirimde bulunmaksızın kendiliğinden tek taraflı
										olarak Kullanım Koşullarını değiştirme, sistemi sürekli veya geçici olarak
										durdurma, uygulama içeriğini değiştirmek, kısıtlamak veya iptal etmekte
										serbesttir. Ücretli uygulamalarda kazanılmış haklar ve tarafların yükümlülükleri
										saklıdır.

									</p>
									<p><b>8.) Hizmet Güncellemeleri ve Değişiklikleri</b>
										</p>
									<p>CDI, internet sitesini ve verdiği hizmetleri güncelleme ve içeriğini değiştirme
										hakkına sahiptir. Ancak CDI, internet sitesi, uygulama ve modüller gibi sair
										hizmetlerin güncel, hatasız veya eksiksiz olduğunu garanti ve taahhüt etmez.
										CDI, en iyi hizmeti hedeflemekle ve bu yolda çalışmakla birlikte, bu hususta
										kesin bir taahhüdü ve yükümlülüğü bulunmamaktadır.


									</p>
									<p><b>9.) Ürün Demoları, Ücretlendirme ve Devir Yasağı</b>

									</p>
									<p><b>9.1.</b> CDI’ya ait İnternet sitesinde yer alan ve IOS veya Android mağazalarında
										bulunan hizmetlerden hangilerinin ücretli veya ücretsiz olacağına yahut
										hangisinin Demo’sunu sunulacağı ve kapsamını belirleme hakkı ve yetkisi
										münhasıran CDI’a aittir. CDI ücretsiz uygulama ve hizmetleri her zaman ücretli
										hale getirme hakkına sahiptir. Bu durum Üye/Kullanıcı için için hiçbir şekilde
										kazanılmış hak teşkil etmez.

									</p>
									<p><b>9.2.</b> CDI’ya ait İnternet sitesinde yer alan ve IOS veya Android mağazalarında
										bulunan uygulama sorgulaması sonuçları yaklaşık sonuçlar olup benzer sitelerdeki
										uygulamalarda çıkacak fiyatlar ve bilgilerle veya genel olarak güncel durumla
										arasında farklılık olabilir. CDI sorgulamadaki bilgilerin ve fiyatlandırmanın
										kesinliği, güncelliği ve doğruluğu gibi hususlar hakkında Üye veya Alıcı’ya
										herhangi bir garanti verilmemekte ve taahhütte bulunulmamaktadır.

									</p>
									<p><b>9.3.</b> Kullanıcı, CDI’ın yazılı onayını almaksızın işbu Kullanım Koşulları’ndaki ve
										bulunması halinde Sözleşmedeki haklarını veya yükümlülüklerini kısmen veya
										tamamen 3.kişilere devredemez, uygulamayı bu anlama gelecek şekilde doğrudan
										veya dolaylı olarak 3.kişilere kullandıramaz. Aksi durumda CDI’ın Üye veya Alıcı
										hakkında her türlü yasal hakkı saklıdır.


									</p>
									<p><b>10.) Hizmetlere Ulaşım ve Güvenlik:</b>

									</p>
									<p><b>10.1.</b> CDI, mevcut hizmet yazılımlarının her cihaz ya da web tarayıcı ile uyumlu
										olduğuna dair bir taahhütte bulunmamaktadır.

									</p>
									<p><b>10.2.</b> CDI olarak, virüs ve benzeri kötü amaçlı yazılımlardan arındırılmış olması
										için piyasadaki benzer standartlar dahilinde tedbir almaktayız. Sizde, hizmete
										erişimde kullandığınız bilgisayar ve mobil cihazlarınız için, kötü ve zarar
										verme amaçlı yazılım veya virüslere karşı tedbirleri almak yükümlülüğüsünüz.
										Aksi taktirde, kötü amaçlı program ve yazılımlar nedeniyle hizmete erişimde
										yaşanabilecek, hata, aksaklık, gecikmelerden dolayı veya sizin veya üçüncü
										kişilerin uğrayabileceği zarardan CDI sorumlu değildir.

									</p>
									<p><b>10.3</b> Üye/Kullanıcıların, CDI sistemlerinin güvenliğini tehdit edebilecek
										girişimlerde bulunması veya uygulamamalara, CDI’a ve diğer kullanıcılara zarar
										verebilecek eylemlerde bulunması, kaynak kodlarına veya CDI’ın sistemlerine
										yetkisiz bir şekilde erişmesi, bu bilgileri kopyalaması, silmesi, değiştirmesi
										ya da bu yönde denemeler yapması yasaktır. Böyle bir durumun veya girişimin
										tespiti halinde CDI ilgililer hakkında her türlü cezai ve hukuk haklarını
										kullanacaktır.

									</p>
									<p><b>11.) Mücbir Sebep:</b>

									</p>
									<p>Hizmetin sunulmasını engelleyen mücbir sebep sayılan tüm durumlarda, CDI Sözleşme
										ile belirlenen edimlerinden herhangi birini; geç veya eksik ifa etmesi veya ifa
										etmemesi nedeniyle sorumlu tutulamaz. Mücbir sebep; doğal afet, isyan, savaş,
										ohal veya sıkıyönetim ilanı, iç karışıklık, grev, lokavt, salgın hastalık,
										telekomünikasyon altyapısından kaynaklanan arızalar, elektrik kesintisi ve kötü
										hava koşulları da dâhil ve fakat bunlarla sınırlı olmamak kaydıyla CDI’ın
										kontrolü haricinde gerçekleşen ve hizmetin verilmesini engelleyen olaylar olarak
										yorumlanacaktır. Mücbir sebep süresince CDI edimleri askıya alınabilecektir.

									</p>
									<p><b>12.) Marka ve Telif Haklarımız:</b>

									</p>
									<p>CDI tarafından sunulan CARDATA uygulaması veya bundan sonra geliştirilerek
										sunulacak tüm uygulama, modül, yazılım, program vs görsel,dijital ve fiziksel
										varlık ve datalar münhasıran CDI’a aitir. CDI tarafından açıkça ve yazılı olarak
										verilmiş bir yetki olmaksızın, CDI ve CDI ait CARDATA, CDI hizmetleri, modül ve
										uygulamalar, görselleri, marka, model, amblem ve logoları, bilgileri,
										yazılımları, web sayfası veya mobil tasarım ve görselleri, telif haklarına
										kapsamında olan olmayan her türlü ürün ve varlığı 3.kişilerce kullanılamaz. Üye
										gerçek veya tüzel kişiler yalnızca uygulamayı/modülü sınırlı süre ve koşullarda
										kullanma imkanı kazanır. Uygulama ve hizmetlerin ücretli veya ücretsiz olarak
										kullanıma sunulması hiçbir şekilde uygulamanın, modülün, yazılım ve veri
										tabanının, görsellerin, tasarım veya isim ve bunlarla sınırlı olmaksızın sair
										hakların devredildiği şekilde yorumlanamaz.

									</p>
									<p><b>13.) Sorumluluğun Sınırlandırılması:</b>

									</p>
									<p>CDI, web sayfası, modül, uygulama ve dataları ile ileride geliştirilerek hizmete
										sunacağı sair uygulama ve ürünlerinde, link verilen veya alınan yerlerde çıkan
										referans fiyatlamalar ve sair bilgiler sadece öngörü/bilgilendirme/fikir verme
										amaçlı olmakla, tam bir kesinlik, doğruluk, güncellik veya buna ilişkin bir
										taahhüt içermemektedir. Belirtilen niteliği gereği bu bilgilerin, sorgulama
										sonuçlarının ve diğer verilerin kullanılması gibi sebeplerle doğabilecek
										doğrudan ya da dolaylı hiçbir zarardan CDI sorumlu değildir.

									</p>
									<p><b>14.) Yetki, Uygulanacak Hukuk ve Delil Sözleşmesi:</b>

									</p>
									<p><b>14.1.</b> Kullanım Koşulları”ndan ve yapılması halinde Sözleşme/lerden kaynaklanacak
										ihtilaflarda İstanbul (Çağlayan) Mahkemeleri ve İcra Daireleri yetkili olup,
										Türk Hukuku’na tabidir.

									</p>
									<p>14.2.Hizmetten Faydalananlar (üye, abone, ziyaretçi/kullanıcı ve her hangi bir
										şekilde internet sitemiz ziyaret eden,uygulama ve modüllerden kullanan tüm
										gerçek ve tüzel kişiler), her hangi bir ihtilaf halinde CDI’ın resmi defter ve
										ticari kayıtları ile veri tabanında, sunucularında tutulan e-arşiv kayıtlarının,
										elektronik bilgilerin, elektronik yazışmaların ve bilgisayar kayıtlarının, iş bu
										kullanım koşullarının ve ayrıca yapılmış bir sözleşme olması halinde sözleşme
										hükümleri ile atıfta bulunulan sair dokümanların taraflar için bağlayıcı, kesin
										ve münhasır delil teşkil edeceğini ve bu maddenin 6100 sayılı Hukuk Muhakemeleri
										Kanunu’nun 193. maddesi anlamında delil sözleşmesi niteliğinde olduğunu kabul
										eder.
									</p>
									<p><b>14.2.</b> İşbu Kullanım Koşulları’nın belli hüküm veya hükümlerinin her hangi bir
										şekilde geçersizliğine karar verilmesi halinde kalan diğer hükümlerin
										geçerliliği koruyacak ve yürürlükte kalmaya devam edecektir.
										</p>
									<p><b>14.3.</b> Taraflar’dan birinin Kullanım Koşulları’nda kendisine verilen herhangi bir
										hakkı kullanmaması ya da icra etmemesi, söz konusu haktan feragat ettiği
										anlamına gelmez, bu durum söz konusu hakkın daha sonra kullanılmasını ya da icra
										edilmesini engellemez.
									</p>
									<p><b>14.5.</b> İşbu Kullanım Koşullarının ve ilgili sözleşme hükümlerinin herhangi birini
										veya tümünü kabul etmemeniz halinde, CDI’ın wep sitesi ve mobil uygumla
										mağazaları vasıtasıyla sunmuş olduğumuz hizmetlerden faydalanamazsınız.

									</p>
									<p><b>15.) Kabul Beyanı, Anlaşma ve KVK :</b> CDI’a ait İnternet Sitesinin ve uygulamaları
										kullanımı, üye kaydı işlemleri sırasında elektronik form üzerinde ve/veya işlem
										adımlarında SMS olarak size gelen doğrulama kodunu/şifreyi girmekle işbu
										Kullanım Koşullarını ve atıfta bulunulan sitemizde/uygulamamızda yer alan diğer
										dokümanları kabul ettiğiniz ve belirtilen tüm koşullara uygun şekilde
										davranacağınızı ve Kişisel Verilerinizin İşlenmesine Açık Rıza verdiğinizi
										kabul, beyan ve taahhüt etmiş olursunuz.
									</p>


								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<script src="js/plugins/owl.carousel.js" type="text/javascript"></script>
	<script src="js/plugins/jquery.fancybox.js" type="text/javascript"></script>
	<script src="js/plugins/sweetalert2.js" type="text/javascript"></script>
	<script src="js/plugins/is.js" type="text/javascript"></script>
	<script src="js/plugins/jquery.lazy.min.js" type="text/javascript"></script>
	<script src="js/plugins/jquery.validate.min.js" type="text/javascript"></script>
	<script src="js/plugins/messages_tr.js" type="text/javascript"></script>
	<script src="js/app.js" type="text/javascript"></script>
	<script src="js/plugins/jquery.marquee.min.js" type="text/javascript"></script>

</body>

</html>